
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.11 3.783a1 1 0 10-1.952.433L13.44 10h2.049L14.11 3.783zM17.512 10H18c.535 0 1.037.14 1.471.385l1.371-6.163a1 1 0 00-1.952-.433L17.512 10zm3.479 2.764c.006.078.009.157.009.236a9 9 0 01-18 0v-2a3 3 0 014.471-2.615 2.998 2.998 0 013.276-1.291l-.542-2.445a3 3 0 115.858-1.299l.438 1.974.436-1.968a3 3 0 115.858 1.299l-1.804 8.11zM11 10a1 1 0 10-2 0v2a1 1 0 001.234.973 5.205 5.205 0 01-.227-1.124 4.774 4.774 0 010-.972v-.001A1 1 0 0111 10zm1.046 2c.053.275.146.567.303.837.31.532.971 1.163 2.651 1.163a1 1 0 01.464 1.886l-.002.001a1.928 1.928 0 00-.317.258c-.216.215-.5.585-.696 1.171a1 1 0 01-1.898-.632c.124-.37.274-.695.435-.976a4.295 4.295 0 01-1.693-1c-.391.187-.83.292-1.293.292-.535 0-1.037-.14-1.471-.385a2.998 2.998 0 01-2.864 1.367A7 7 0 0019 13a1 1 0 00-1-1h-5.954zM5 13a1 1 0 102 0v-2a1 1 0 10-2 0v2z"}})])
          )
        }
      }
    